/* global axios */
import ApiClient from './ApiClient';

class DealCustomFieldsAPI extends ApiClient {
  constructor() {
    super('deal_custom_fields', { accountScoped: true });
  }

  // Get all custom field definitions
  get(params = {}) {
    const queryParams = new URLSearchParams();

    if (params.funnel_id) queryParams.append('funnel_id', params.funnel_id);
    if (params.active_only) queryParams.append('active_only', 'true');

    const queryString = queryParams.toString();
    return axios.get(queryString ? `${this.url}?${queryString}` : this.url);
  }

  // Get a specific field definition
  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // Create a new custom field
  create(fieldData) {
    return axios.post(this.url, { deal_custom_field: fieldData });
  }

  // Update a custom field
  update(id, fieldData) {
    return axios.patch(`${this.url}/${id}`, { deal_custom_field: fieldData });
  }

  // Delete a custom field
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Reorder a single field
  reorder(id, position) {
    return axios.post(`${this.url}/${id}/reorder`, { position });
  }

  // Bulk reorder fields
  bulkReorder(positions) {
    return axios.post(`${this.url}/bulk_reorder`, { positions });
  }

  // Get field type configurations
  getFieldTypes() {
    return axios.get(`${this.url}/field_types`);
  }

  // Get all field values for a specific deal
  getValuesForDeal(dealId) {
    return axios.get(`${this.url}/values_for_deal`, {
      params: { deal_id: dealId },
    });
  }

  // Set multiple field values for a deal
  setValuesForDeal(dealId, values) {
    return axios.post(`${this.url}/set_values_for_deal`, {
      deal_id: dealId,
      values,
    });
  }

  // Set a single field value for a deal
  setFieldValue(dealId, fieldKey, value) {
    return axios.post(`${this.url}/set_field_value`, {
      deal_id: dealId,
      field_key: fieldKey,
      value,
    });
  }
}

export default new DealCustomFieldsAPI();
